import { useEffect } from "react";
import NavBar from "../components/NavBar";
import "./reviews.css";
import ym from "react-yandex-metrika";

export default function Reviews() {
  useEffect(() => {
    ym("reachGoal", "reviews_page_visit");
  }, []);

  return (
    <main>
      <NavBar />
      <h1 className="reviews-title">Отзывы о моей работе</h1>
      <p className="emoji emoji_heart">❤️</p>
      <p className="emoji emoji_star">✨</p>
      <div id="mywrap">
        <div class="tg-wrap">
          <img
            className="tg-wrap-iphone"
            src={`${process.env.PUBLIC_URL}/cifon2.png`}
            loading="lazy"
            alt=""
          />
          <div class="tg-inner">
            <div class="plashka"></div>
            <iframe
              theme="white"
              id="preview"
              title="отзывы"
              src={`${process.env.PUBLIC_URL}/iframe.html`}
            ></iframe>
          </div>
        </div>
      </div>
    </main>
  );
}
